import useMapModalStore from '../../../../stores/useMapModalStore';
import PlotTakenModal from '../../../../ui/modals/map/PlotTakenModal';

/** Taken-plot modal (`activeModal === 'plotTaken'`). Fully store-driven. JSX moved verbatim. */
export default function PlotTakenHost() {
  const isPlotTakenModalOpen = useMapModalStore((s) => s.activeModal === 'plotTaken');
  const closeModal = useMapModalStore((s) => s.closeModal);

  return (
        <PlotTakenModal
          isOpen={isPlotTakenModalOpen}
          onClose={closeModal}
        />
  );
}
